import React, { useEffect } from 'react'
import {Titulo} from 'asocomponents'
import Layout from '../layouts/Layout'
import { useNavigate } from 'react-router-dom'
import FiltrosPagosSinFacturaContainer from '../../components/organismos/FiltrosPagosSinFacturaContainer/FiltrosPagosSinFacturaContainer'
import GrillaPagosSinFacturaContainer from '../../components/organismos/GrillaPagosSinFacturaContainer/GrillaPagosSinFacturaContainer'

function GrillaPagosSinFactura() {
  const navigate = useNavigate()
  const redireccionar=()=>navigate('/loguin')  

  //Valido si el usuario esta logueado sino se lo redirecciona al loguin
  useEffect(() => {
    const usuarioGuardado = sessionStorage.getItem('usuario')
    if (!usuarioGuardado) {
      redireccionar()
    }
  }, [])

  return (
    <Layout>
      <Titulo titulo="Pagos sin Factura"/>
      <FiltrosPagosSinFacturaContainer />
      <GrillaPagosSinFacturaContainer />
    </Layout>
  )
}

export default GrillaPagosSinFactura
